import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import PropTypes from 'prop-types';
import * as actions from '../../action';

function FloorArea({
  onChange, floor_storey_areas,
  total_floor_area,
  no_of_storeys,
  modalType,
  totalAdditionalItems
}) {

  const [formData, setFormData] = useState([]);
  const [floorNumber, setFloorNumber] = useState(no_of_storeys || 0);
  const [totalSum, setTotalSum] = useState(0);

  const formatFloorArea = (data) => {
    const format = data.map((item, i) => ({
      id: i + 1,
      floor: item.floor,
      area: item.area,
    }));
    return format;
  };

  useEffect(() => {
    if (modalType === 'EDIT') {
      setFormData(formatFloorArea(floor_storey_areas));
      setTotalSum(total_floor_area);
      setFloorNumber(no_of_storeys);
    } else {
      setFormData(floor_storey_areas);
    }
  }, []);

  const handleOnChangeRow = (key, index) => (e) => {
    const updatedFormData = formData.map((item) =>
      +item.id === +index
        ? { ...item, [key]: e.target.value }
        : item
    );

    const updatedTotal = updatedFormData.reduce(
      (sum, row) => sum + Number(row.area || 0),
      0
    );

    setTotalSum(+updatedTotal + +totalAdditionalItems);

    setFormData(updatedFormData);

    const args = {
      floor_storey_areas: updatedFormData,
      total_floor_area: updatedTotal,
      no_of_storeys: floorNumber
    };

    onChange(args);
  };

  const handleOnChange = (e) => {
    setFloorNumber(0);
    setFloorNumber(e.target.value);

    const updatedTotal = formData.reduce(
      (sum, row) => sum + Number(row.area || 0),
      0
    );

    setTotalSum(+updatedTotal + +totalAdditionalItems);

    const args = {
      floor_storey_areas: formData,
      total_floor_area: updatedTotal,
      no_of_storeys: e.target.value
    };

    onChange(args);
  };

  const handleAddFloor = () => {
    const array = [];
    for (let i = 0; i < floorNumber; i += 1) {
      array.push({
        id: i,
        floor: i + 1,
        area: '',
      });
    }
    setFormData(array);
  };

  const handleRemoveFloorArea = () => {
    const newItem = formData.slice(0, -1);
    setFormData(newItem);

    const args = {
      floor_storey_areas: formData,
    };

    onChange(args);

    if (formData.length === 1) {
      setFloorNumber(0);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-6 form-group">
          <label className="form-label">
            No of Storeys
          </label>
          <div
            className="input-group mb-3 col-12 mt-2"
            style={{ marginLeft: -15 }}
          >
            <input
              className="form-control"
              type="number"
              id="floorNumber"
              name="floorNumber"
              autoComplete="none"
              min="1"
              onChange={handleOnChange}
              value={floorNumber || ''}
            />
            <div className="input-group-append">
              <button
                type="button"
                onClick={handleAddFloor}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold"
              >
                <i className="fas fa-plus" /> Add
              </button>
            </div>
          </div>
        </div>
        <div className="col-6">
          <label className="form-label">
            Total Floor Area
          </label>
          <input
            readOnly
            className="form-control"
            type="number"
            id="totalFloorArea"
            name="totalFloorArea"
            autoComplete="none"
            value={totalSum || 0}
          />
        </div>
        <div className="col-12">
          <table className="table-lease table table-sm mt-2 scroll-table">
            <thead>
              <tr className="cms-bg-color-primary-light cms-text-primary">
                <th>Floor Number</th>
                <th>Floor Area</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {formData.map((el, index) => (
                <tr key={`floor-${el.id}`}>
                  {(modalType === 'EDIT' && _.isEmpty(el.floor)) ?
                    (
                      <td>
                        {el.floor}
                      </td>
                    ) : (
                      <td>
                        {index + 1}
                      </td>
                    )}
                  <td>
                    <input
                      className="form-control"
                      type="number"
                      id="area"
                      name="area"
                      autoComplete="none"
                      onChange={handleOnChangeRow('area', modalType === 'EDIT' ? index + 1 : index)}
                      value={_.get(el, 'area') || ''}
                    />
                  </td>
                  {index === formData.length - 1 && (
                    <td>
                      <button type="button" className="btn btn-blank" onClick={handleRemoveFloorArea}>
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

FloorArea.defaultProps = {
  modalType: '',
  total_floor_area: 0,
  floor_storey_areas: [],
  no_of_storeys: 0,
  totalAdditionalItems: 0
};

FloorArea.propTypes = {
  modalType: PropTypes.string,
  totalAdditionalItems: PropTypes.number,
  total_floor_area: PropTypes.number,
  no_of_storeys: PropTypes.number,
  floor_storey_areas: PropTypes.instanceOf(Array),
  onChange: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(FloorArea);
